/* Copyright (c) 2018-2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SingleEventStream } from '../event-stream/event-streams';

@Injectable({
    providedIn: 'root'
})
export class SingleEventStreamFactoryService {
    createStream<T>(
        workerFn: () => Observable<T>,
        lazyInit = true,
        cacheLastResult = true,
        clearCacheOnRefresh = true,
        cacheLifeTime = -1
    ): SingleEventStream<T> {
        return new SingleEventStream(workerFn, lazyInit, cacheLastResult, clearCacheOnRefresh, cacheLifeTime);
    }
}
